/* @flow */

import CommissionSummaryIsoQuarter from './commissionSummaryIsoQuarter';

export default class CommissionSummaryIsoPerson {
  id: number;
  name: string;
  quarters: CommissionSummaryIsoQuarter[];
  financedInvoiceCommission: number;
  unfinancedInvoiceCommission: number;
  msfCommission: number;
  membershipCommission: number;
  totalCommission: number;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
    this.quarters = [];
    this.financedInvoiceCommission = 0;
    this.unfinancedInvoiceCommission = 0;
    this.msfCommission = 0;
    this.membershipCommission = 0;
    this.totalCommission = 0;
  }
}
